module.exports = __webpack_public_path__ + "img/sms.4cb11483.png";